var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 108,
    viewBox: "0 0 106 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5771 65.7895L85.9982 58.9474C87.5771 53.2632 87.6824 47.1053 85.9982 40.9474L95.5771 34.2105L87.9455 21.0526L77.2613 25.8947C73.1034 21.6842 67.8403 18.4211 61.6824 16.8947L60.6297 5.26316H45.3666L44.3139 16.8947C38.156 18.4211 32.8929 21.6842 28.735 25.8947L18.0508 21.0526L10.4192 34.2105L19.9982 40.9474C18.3139 47.1053 18.4192 53.2632 19.9982 58.9474L10.4192 65.7895L18.0508 78.9474L28.735 74.0526C32.8929 78.2105 38.156 81.3684 44.3139 83L45.3666 94.7368H60.6297L61.6824 83C67.8403 81.3684 73.1034 78.2105 77.2613 74.0526L87.9455 78.9474L95.5771 65.7895ZM63.5245 0C64.9455 0 66.156 1.05263 66.156 2.42105L67.1034 13.1579C71.1034 14.6316 74.6824 16.7895 77.8929 19.3684L87.6297 14.7895C88.8403 14.1579 90.3666 14.5789 91.1034 15.7895L101.63 34.2105C102.367 35.3158 101.946 36.8421 100.788 37.6316L91.9981 43.7895C92.6824 48 92.6297 52.1579 91.9981 56.2105L100.788 62.3684C101.946 63.1579 102.367 64.6842 101.63 65.7895L91.1034 84.2105C90.3666 85.3158 88.8403 85.7368 87.6297 85.1053L77.8929 80.5789C74.6824 83.1579 71.1034 85.2632 67.1034 86.8421L66.156 97.3684C66.156 98.8947 64.9455 100 63.5245 100H42.4718C41.7739 100 41.1045 99.7227 40.611 99.2292C40.1175 98.7357 39.8403 98.0664 39.8403 97.3684L38.8929 86.8421C34.8929 85.2632 31.3139 83.1579 28.1034 80.5789L18.3666 85.1053C17.156 85.7368 15.6297 85.3158 14.8929 84.2105L4.36657 65.7895C3.62973 64.6842 4.05078 63.1579 5.20868 62.3684L13.9982 56.2105C13.3666 52.1579 13.3139 48 13.9982 43.7895L5.20868 37.6316C4.05078 36.8421 3.62973 35.3158 4.36657 34.2105L14.8929 15.7895C15.6297 14.5789 17.156 14.1579 18.3666 14.7895L28.1034 19.3684C31.3139 16.7895 34.8929 14.6316 38.8929 13.1579L39.8403 2.42105C39.8403 1.05263 41.0508 0 42.4718 0H63.5245ZM52.9981 31.5789C57.8837 31.5789 62.5692 33.5197 66.0238 36.9743C69.4784 40.429 71.4192 45.1144 71.4192 50C71.4192 54.8856 69.4784 59.571 66.0238 63.0256C62.5692 66.4803 57.8837 68.4211 52.9981 68.4211C48.1126 68.4211 43.4271 66.4803 39.9725 63.0256C36.5179 59.571 34.5771 54.8856 34.5771 50C34.5771 45.1144 36.5179 40.429 39.9725 36.9743C43.4271 33.5197 48.1126 31.5789 52.9981 31.5789ZM52.9981 36.8421C49.5085 36.8421 46.1617 38.2284 43.6941 40.696C41.2265 43.1635 39.8403 46.5103 39.8403 50C39.8403 53.4897 41.2265 56.8365 43.6941 59.304C46.1617 61.7716 49.5085 63.1579 52.9981 63.1579C56.4878 63.1579 59.8346 61.7716 62.3022 59.304C64.7698 56.8365 66.156 53.4897 66.156 50C66.156 46.5103 64.7698 43.1635 62.3022 40.696C59.8346 38.2284 56.4878 36.8421 52.9981 36.8421Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_35",
    x: 0,
    y: 0,
    width: 105.996,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_35"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_35",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.939884b62a06fbb15d881ecfafc38682.svg";
export { ForwardRef as ReactComponent };